export default {
  nav: {
    careers: 'კარიერა',
    admin: 'ადმინისტრატორი',
    backToStore: 'მაღაზიაში დაბრუნება',
    results: 'შედეგები'
  },
  hero: {
    badge: 'ჩვენ ვეძებთ',
    title: 'ვინ ვართ ჩვენ?',
    goal: 'ჩვენი მიზანი',
    seeMore: 'იხილეთ მეტი',
    seeLess: 'ნაკლები',
    subtitle: `კომპანია, რომელიც მუდმივ ზრდასა და განვითარებაზეა ორიენტირებული.
ტექნიკა მხოლოდ პროდუქტი არ არის — ესა შესაძლებლობა, რომელიც ადამიანებს ყოველდღიურ ცხოვრებას უმარტივებს, აჩქარებს და უფრო ეფექტურს ხდის. ჩვენი მიზანია, შევქმნათ სანდო, თანამედროვე და მომხმარებელზე ორიენტირებული ტექნოლოგიური ეკოსისტემა, სადაც ხარისხი, გამჭვირვალობა და პროფესიონალიზმი პირველ ადგილზეა.`,
    stats: {
      teamCount: '150000+',
      team: 'მომხმარებელი',
      locationsCount: '50+',
      locations: 'გუნდის წევრი',
      openRolesCount: '20+',
      openRoles: 'ფილიალი'
    }
  },
  careers: {
    locationNotSpecified: 'არ არის მითითებული',
    locationOptions: {
      onsite: 'ოფისში',
      remote: 'დისტანციური',
      hybrid: 'ჰიბრიდული'
    },
    title: 'მიმდინარე ვაკანსიები',
    subtitle: 'აქციე შენი ამბიცია ინოვაციად',
    filters: {
      all: 'ყველა'
    },
    departments: {
      engineering: 'ინჟინერია',
      design: 'დიზაინი',
      marketing: 'მარკეტინგი'
    },
    salary: 'ხელფასი',
    viewDetails: 'დეტალების ნახვა',
    sendResume: 'რეზიუმეს გაგზავნა',
    applicants: 'განაცხადი',
    deadline: 'ბოლო ვადა',
    positionClosed: 'პოზიცია დახურულია',
    noVacancies: 'ამჟამად ვაკანსიები არ არის. შეამოწმე მოგვიანებით!',
    loading: 'ვაკანსიების ჩატვირთვა...',
    status: {
      open: 'მიმდინარე',
      'closing-soon': 'მალე იხურება',
      closed: 'დახურული'
    },
    warnings: {
      contact: 'გაითვალისწინეთ, რომ მხოლოდ შეურჩეულ კანდიდატებს დავუკავშირდებით',
      consent: 'რეზიუმეს გამოგზავნით ავტომატურად ეთანხმებით ჯისთორის უფლებამოსილებას, კანონმდებლობით გათვალისწინებული წესით, მიზნითა და ვადით დაამუშავოს, შეინახოს და გამოიყენოს თქვენი პერსონალური მონაცემები'
    },
    introduce: {
      title: 'შემოგვთავაზე შენი თავი',
      description: 'ვერ იპოვნე შენთვის შესაფერისი ვაკანსია და მაინც ფიქრობ, რომ ჩვენ შენ გვჭირდები? მაშინ შემოგვთავაზე შენი თავი.',
      button: 'შემოგვთავაზე'
    }
  },
  vacancyDetails: {
    title: 'დეტალები',
    description: 'სამუშაოს აღწერა',
    salary: 'ხელფასი',
    responsibilities: 'ძირითადი პასუხისმგებლობები',
    requirements: 'მოთხოვნები',
    benefits: 'რას გთავაზობთ',
    posted: 'გამოქვეყნდა',
    deadline: 'განაცხადის ბოლო ვადა',
    applyNow: 'რეზიუმეს გაგზავნა',
    resp1: 'პროექტების ხელმძღვანელობა და მართვა დაწყებიდან დასრულებამდე',
    resp2: 'თანამშრომლობა Cross-Function გუნდებთან მიზნების მისაღწევად',
    resp3: 'სტრატეგიული ინიციატივების შემუშავება და განხორციელება',
    resp4: 'გუნდის წევრების მენტორობა და მხარდაჭერა უნარების გასაუმჯობესებლად',
    resp5: 'KPI მონიტორინგი და რეგულარული ანგარიშების მომზადება',
    req1: 'ბაკალავრის ხარისხი შესაბამის სფეროში ან ექვივალენტური გამოცდილება',
    req2: '3+ წლის გამოცდილება მსგავს როლში',
    req3: 'ძლიერი კომუნიკაციის და ინტერპერსონალური უნარები',
    req4: 'დადასტურებული შედეგების მიღწევის გამოცდილება',
    req5: 'სწრაფ ტემპიან გარემოში მუშაობის უნარი',
    benefit1: 'კონკურენტული ხელფასი და ბონუსები',
    benefit2: 'ჯანმრთელობის დაზღვევა',
    benefit3: 'მოქნილი სამუშაო საათები და დისტანციური მუშაობის შესაძლებლობა',
    benefit4: 'პროფესიული განვითარებისა და ტრენინგის შესაძლებლობები',
    benefit5: 'მეგობრული და ინკლუზიური სამუშაო გარემო'
  },
  applyModal: {
    title: 'განაცხადის გაგზავნა',
    name: 'სრული სახელი',
    email: 'ელ. ფოსტა',
    phone: 'ტელეფონის ნომერი',
    position: 'პოზიცია',
    selectPosition: 'აირჩიეთ პოზიცია',
    desiredPosition: 'სასურველი პოზიცია',
    desiredPositionPlaceholder: 'მაგ. პროდუქტის მენეჯერი',
    location: 'ლოკაცია',
    selectLocation: 'აირჩიეთ ლოკაცია',
    employmentType: 'დასაქმების ტიპი',
    selectEmploymentType: 'აირჩიეთ დასაქმების ტიპი',
    salaryMin: 'მინიმალური ხელფასი',
    salaryMax: 'მაქსიმალური ხელფასი',
    locationOptions: {
      onsite: 'ოფისში',
      hybrid: 'ჰიბრიდული',
      remote: 'დისტანციური'
    },
    employment: {
      fullTime: 'სრული',
      partTime: 'ნახევარ განაკვეთი',
      project: 'პროექტი'
    },
    resume: 'რეზიუმეს ატვირთვა (PDF)',
    coverLetter: 'სამოტივაციო წერილი',
    coverLetterPlaceholder: 'მოგვიყევი რატომ ხარ შესაფერისი ამ პოზიციისთვის...',
    submit: 'განაცხადის გაგზავნა',
    submitting: 'იგზავნება...',
    cancel: 'გაუქმება',
    successTitle: 'განაცხადი გაგზავნილია!',
    success: 'მადლობა განაცხადისთვის. ჩვენ განვიხილავთ თქვენს განაცხადს და მალე დაგიკავშირდებით.',
    error: 'განაცხადის გაგზავნა ვერ მოხერხდა. გთხოვთ სცადოთ თავიდან.'
  },
  admin: {
    tabs: {
      applications: 'აპლიკაციები',
      selection: 'შერჩევა',
      status: 'სტატუსი',
      vacancies: 'ვაკანსიები',
      blueprints: 'ბლუპრინტები',
      settings: 'პარამეტრები'
    },
    applications: {
      title: 'გამოგზავნილი აპლიკაციები',
      stats: {
        total: 'ყველა აპლიკანტი',
        thisMonth: 'ამ თვეში',
        thisWeek: 'ამ კვირაში',
        general: 'შემოგვთავაზე შენი თავი',
        perVacancy: 'აპლიკანტები ვაკანსიების მიხედვით',
        accepted: 'მიღებული',
        rejected: 'უარყოფილი',
        pending: 'მოლოდინში',
        deleted: 'წაშლილი'
      },
      filters: {
        allVacancies: 'ყველა ვაკანსია',
        general: 'შემოგვთავაზე შენი თავი',
        dateFrom: 'თარიღიდან',
        dateTo: 'თარიღამდე',
        search: 'ძებნა სახელით ან ელ. ფოსტით...',
        searchLabel: 'ძებნა',
        vacancyLabel: 'ვაკანსია',
        dateFromLabel: 'თარიღიდან',
        dateToLabel: 'თარიღამდე',
        sortBy: 'დალაგება',
        dateNewest: 'ახალი',
        dateOldest: 'ძველი',
        nameAsc: 'სახელი (ა-ჰ)',
        nameDesc: 'სახელი (ჰ-ა)',
        accepted: 'მიღებული',
        rejected: 'უარყოფილი',
        deleted: 'წაშლილი',
        activeFilters: 'აქტიური ფილტრები',
        none: 'არცერთი',
        resetFilters: 'ფილტრების გასუფთავება'
      },
      table: {
        name: 'სახელი',
        email: 'ელ. ფოსტა',
        phone: 'ტელეფონი',
        vacancy: 'პოზიცია',
        assignedPosition: 'მიბმული პოზიცია',
        date: 'გაგზავნილია',
        resume: 'რეზიუმე',
        coverLetter: 'სამოტივაციო წერილი',
        download: 'ჩამოტვირთვა',
        downloadResume: 'რეზიუმეს ჩამოტვირთვა',
        view: 'ნახვა',
        actions: 'მოქმედებები'
      },
      selected: 'არჩეული',
      bulkDownload: 'არჩეულის ჩამოტვირთვა',
      bulkDelete: 'არჩეულის წაშლა',
      bulkDeleteConfirm: 'დარწმუნებული ხართ, რომ გსურთ არჩეული აპლიკაციის წაშლა?',
      deleteConfirm: 'დარწმუნებული ხართ, რომ გსურთ ამ აპლიკაციის წაშლა?',
      generalTitle: 'შემოგვთავაზე შენი თავი',
      viewTitle: 'აპლიკაციის დეტალები',
      assignment: {
        title: 'პოზიციის მინიჭება',
        label: 'აირჩიეთ აქტიური ვაკანსია',
        placeholder: 'აირჩიეთ ვაკანსია',
        confirm: 'მინიჭება',
        required: 'გთხოვთ აირჩიოთ ვაკანსია.',
        edit: 'მიბმული პოზიციის შეცვლა',
        noActiveVacancies: 'აქტიური ვაკანსია არ მოიძებნა.'
      },
      details: {
        desiredPosition: 'სასურველი პოზიცია',
        locationPreference: 'ლოკაციის პრეფერენცია',
        employmentType: 'დასაქმების ტიპი',
        salaryMin: 'მინიმალური ხელფასი',
        salaryMax: 'მაქსიმალური ხელფასი'
      },
      actions: {
        view: 'ნახვა',
        download: 'ჩამოტვირთვა',
        accept: 'მიღება',
        reject: 'უარყოფა',
        delete: 'წაშლა',
        export: 'ექსპორტი',
        restore: 'აღდგენა',
        confirmStatusTitle: 'სტატუსის დადასტურება',
        confirmStatus: 'გსურთ {{count}} აპლიკაციის სტატუსი გადავაყენოთ {{status}}-ზე?',
        confirmDeleteTitle: 'წაშლის დადასტურება',
        confirmDelete: 'გსურთ {{count}} აპლიკაციის წაშლა?',
        deletePermanently: 'წაშლა სამუდამოდ (30 დღიანი დაყოვნების გარეშე)',
        confirm: 'დადასტურება',
        statusUpdated: 'სტატუსი განახლდა: {{status}}.',
        deleted: 'აპლიკაცია წაიშალა.',
        deletedPermanent: 'აპლიკაცია სამუდამოდ წაიშალა.',
        downloaded: 'ჩამოტვირთვა დასრულდა.',
        downloadError: 'რეზიუმეს ჩამოტვირთვა ვერ მოხერხდა.',
        exported: 'ექსპორტი მზადაა.',
        noResume: 'რეზიუმე არ არის მიმაგრებული.',
        actionFailed: 'მოქმედება ვერ შესრულდა. სცადეთ თავიდან.',
        loading: 'მოაქვთ მეტი...',
        endOfList: 'სია დასრულდა.',
        exportError: 'ექსპორტი ვერ შესრულდა.',
        comingSoon: 'ეს მოქმედება მალე დაემატება.'
      },
      status: {
        pending: 'მოლოდინში',
        accepted: 'მიღებული',
        rejected: 'უარყოფილი',
        deleted: 'წაშლილი'
      },
      noApplications: 'აპლიკაციის არ მოიძებნა'
    },
    vacancies: {
      title: 'ვაკანსიების მართვა',
      addNew: 'ახალი ვაკანსიის დამატება',
      edit: 'რედაქტირება',
      delete: 'წაშლა',
      deleteConfirm: 'დარწმუნებული ხართ, რომ გსურთ ამ ვაკანსიის წაშლა?',
      posted: 'გამოქვეყნდა',
      deadline: 'ბოლო ვადა',
      applicants: 'განაცხადი',
      expired: 'ვადაგასული',
      closingSoon: 'მალე იხურება',
      noVacancies: 'ვაკანსიები არ მოიძებნა',
      status: {
        open: 'მიმდინარე',
        'closing-soon': 'მალე იხურება',
        closed: 'დახურული'
      },
      form: {
        title: 'პოზიციის დასახელება',
        department: 'დეპარტამენტი',
        location: 'ლოკაცია',
        type: 'დასაქმების ტიპი',
        status: 'სტატუსი',
        deadline: 'განაცხადის ბოლო ვადა',
        salaryRange: 'ხელფასის დიაპაზონი',
        salaryMin: 'მინიმალური ხელფასი',
        salaryMax: 'მაქსიმალური ხელფასი',
        currency: 'ვალუტა',
        description: 'სამუშაოს აღწერა',
        descriptionPlaceholder: 'აღწერეთ როლი და პასუხისმგებლობები...',
        responsibilities: 'ძირითადი პასუხისმგებლობები',
        responsibilityPlaceholder: 'დაამატეთ პასუხისმგებლობა',
        requirements: 'მოთხოვნები',
        requirementPlaceholder: 'დაამატეთ მოთხოვნა',
        benefits: 'სარგებელი',
        benefitPlaceholder: 'დაამატეთ სარგებელი',
        visitLocation: 'ვიზიტის ადგილი (Google Maps ბმული)',
        visitLocationPlaceholder: 'ჩასვით Google Maps ბმული ან მისამართი',
        createBlank: 'ცარიელიდან შექმნა',
        createFromBlueprint: 'ბლუპრინტიდან შექმნა',
        selectBlueprint: 'ვაკანსიის ბლუპრინტის არჩევა',
        selectBlueprintPlaceholder: 'აირჩიეთ ბლუპრინტი',
        saveBlueprint: 'ბლუპრინტად შენახვა',
        blueprintNamePlaceholder: 'ბლუპრინტის სახელი (უნიკალური)',
        addItem: 'დამატება',
        save: 'ვაკანსიის შენახვა',
        cancel: 'გაუქმება',
        editTitle: 'ვაკანსიის რედაქტირება',
        createTitle: 'ახალი ვაკანსიის შექმნა',
        locationOptions: {
          onsite: 'ოფისში',
          remote: 'დისტანციური',
          hybrid: 'ჰიბრიდული'
        },
        typeOptions: {
          fullTime: 'სრული',
          partTime: 'ნახევარ განაკვეთი',
          project: 'პროექტი'
        }
      }
    },
    blueprints: {
      selection: 'შერჩევის ბლუპრინტები',
      vacancy: 'ვაკანსიის ბლუპრინტები',
      selectionList: 'შერჩევის ბლუპრინტები',
      vacancyList: 'ვაკანსიის ბლუპრინტები',
      empty: 'ბლუპრინტები ჯერ არ არის.',
      stagesCount: '{{count}} ეტაპი',
      vacancyFields: 'ვაკანსიის შაბლონი'
    },
    settings: {
      title: 'პლატფორმის მომხმარებლები',
      subtitle: 'შექმენით ანგარიშები და მართეთ ადმინისტრაციული წვდომა.',
      addUser: 'მომხმარებლის დამატება',
      editUser: 'მომხმარებლის რედაქტირება',
      user: 'მომხმარებელი',
      role: 'როლი',
      status: 'სტატუსი',
      lastSignIn: 'ბოლო შესვლა',
      actions: 'მოქმედებები',
      fullName: 'სახელი და გვარი',
      email: 'ელ. ფოსტა',
      password: 'პაროლი',
      newPassword: 'ახალი პაროლი',
      passwordOptional: 'დატოვეთ ცარიელი არსებული პაროლის შესანარჩუნებლად',
      save: 'შენახვა',
      superAdmin: 'სუპერ ადმინისტრატორი',
      adminRole: 'ადმინისტრატორი',
      active: 'აქტიური',
      suspended: 'შეჩერებული',
      you: 'თქვენ',
      edit: 'რედაქტირება',
      suspend: 'შეჩერება',
      activate: 'გააქტიურება',
      delete: 'წაშლა',
      loading: 'მომხმარებლები იტვირთება...',
      noUsers: 'პლატფორმის მომხმარებლები ვერ მოიძებნა.',
      validEmail: 'შეიყვანეთ სწორი ელ. ფოსტის მისამართი.',
      passwordMinimum: 'პაროლი უნდა შეიცავდეს მინიმუმ 8 სიმბოლოს.',
      loadFailed: 'მომხმარებლების ჩატვირთვა ვერ მოხერხდა.',
      actionFailed: 'მოქმედება ვერ შესრულდა.',
      userCreated: 'მომხმარებელი წარმატებით შეიქმნა.',
      userUpdated: 'მომხმარებელი წარმატებით განახლდა.',
      userSuspended: 'მომხმარებელი შეჩერებულია.',
      userActivated: 'მომხმარებელი გააქტიურებულია.',
      userDeleted: 'მომხმარებელი წაიშალა.',
      suspendConfirm: 'შევაჩეროთ {{email}}?',
      activateConfirm: 'გავააქტიუროთ {{email}}?',
      deleteConfirm: 'სამუდამოდ წავშალოთ {{email}}? მოქმედების გაუქმება შეუძლებელია.'
    },
    selection: {
      loading: 'იტვირთება შერჩევა...',
      applicants: 'მიღებული კანდიდატები',
      total: 'სულ',
      view: 'ნახვა',
      name: 'სახელი',
      email: 'ელ. ფოსტა',
      phone: 'ტელეფონი',
      code: 'კოდი',
      actions: 'მოქმედებები',
      codeRefresh: 'კოდის გენერირება',
      codeGenerated: 'კანდიდატის კოდი შეიქმნა.',
      codeFailed: 'კოდის გენერირება ვერ მოხერხდა. სცადეთ ხელახლა.',
      codePartial: 'ზოგიერთი კოდის გენერირება ვერ მოხერხდა.',
      stageLabel: 'ეტაპი',
      meetModeLabel: 'შეხვედრის ბმულის რეჟიმი',
      meetModeAuto: 'ავტომატური (დროები)',
      meetModeManual: 'ხელით',
      manualLinksTitle: 'შეხვედრის ბმულები ხელით',
      manualLinksHint: 'ბმული საჭიროა მხოლოდ მიღებულებისთვის.',
      manualLinkPlaceholder: 'ჩასვით შეხვედრის ბმული',
      manualLinksEmpty: 'აირჩიეთ “pass” კანდიდატები ბმულის დასამატებლად.',
      visitLocation: 'ვიზიტის ადგილი',
      visitLocationPlaceholder: 'შეიყვანეთ მისამართი ან შეხვედრის ადგილი',
      slotsTitleStage: 'ეტაპი {{stage}} დროები',
      slotsSubtitleStage: 'დროების შექმნა (GMT+4).',
      blueprintsTitle: 'შერჩევის ბლუპრინტები',
      blueprintsSubtitle: 'გამოიყენეთ ან შეინახეთ შერჩევის ნაკადები.',
      selectBlueprint: 'ბლუპრინტის არჩევა',
      selectBlueprintPlaceholder: 'ცარიელიდან შექმნა',
      applyBlueprint: 'ბლუპრინტის გამოყენება',
      saveBlueprint: 'ბლუპრინტის შენახვა',
      blueprintNamePlaceholder: 'ახალი ბლუპრინტის სახელი',
      blueprintApplied: 'ბლუპრინტი გამოიყენეს.',
      blueprintApplyFailed: 'ბლუპრინტის გამოყენება ვერ მოხერხდა.',
      blueprintSaved: 'ბლუპრინტი შეინახა.',
      blueprintSaveFailed: 'ბლუპრინტის შენახვა ვერ მოხერხდა.',
      blueprintNameRequired: 'შეიყვანეთ უნიკალური ბლუპრინტის სახელი.',
      stagesTitle: 'ეტაპები',
      stagesSubtitle: 'გადაათრიეთ რიგის შესაცვლელად, დაამატეთ ან წაშალეთ.',
      addStage: 'ეტაპის დამატება',
      stageAddFailed: 'ეტაპის დამატება ვერ მოხერხდა.',
      stageRemoveConfirm: 'წავშალოთ ეს ეტაპი?',
      stageRemoveFailed: 'ეტაპის წაშლა ვერ მოხერხდა.',
      stageOrderFailed: 'ეტაპების გადალაგება ვერ მოხერხდა.',
      stageType: 'ეტაპის ტიპი',
      stageTypeTask: 'დავალება',
      stageTypeOnline: 'ონლაინ ინტერვიუ',
      stageTypeVisit: 'ვიზიტი',
      stageTypeCustom: 'სხვა',
      enableSlots: 'დროების ჩართვა',
      applyBlueprintConfirm: 'ბლუპრინტის გამოყენება არსებული ეტაპებს შეცვლის. გავაგრძელოთ?',
      stageDefault: 'ეტაპი {{number}}',
      removeStage: 'ეტაპის წაშლა',
      slotsTitle: 'ეტაპი 2 დროები',
      slotsSubtitle: 'ინტერვიუს დროების შექმნა (GMT+4).',
      slotsCount: 'დროების რაოდენობა',
      startDate: 'დაწყების თარიღი',
      endDate: 'დასრულების თარიღი',
      startTime: 'დაწყების დრო',
      endTime: 'დასრულების დრო',
      slotDuration: 'დროის ხანგრძლივობა (წუთი)',
      slotsCreate: 'დროების შექმნა',
      slotsCreating: 'მზადდება...',
      slotsInvalid: 'გადაამოწმეთ თარიღის/დროის შუალედი.',
      slotsCreated: 'დროები შეიქმნა.',
      slotsFailed: 'დროების შექმნა ვერ მოხერხდა.',
      slotsPreview: 'მომავალი დროების ნახვა',
      slotsTimezone: 'GMT+4',
      slotsPreviewEmpty: 'დროები ჯერ არ არის.',
      stage1: { title: 'ეტაპი 1 - მინი დავალება' },
      stage2: { title: 'ეტაპი 2 - ინტერვიუ' },
      stage3: { title: 'ეტაპი 3 - ვიზიტი' },
      stageTitlePlaceholder: 'ეტაპის სათაური',
      successText: 'დამტკიცების ტექსტი',
      failText: 'უარყოფის ტექსტი',
      meetLink: 'Google Meet ბმული',
      saveDraft: 'დრეფტის შენახვა',
      saving: 'ინახება...',
      send: 'გაგზავნა',
      sending: 'იგზავნება...',
      uploadHint: 'გადმოიტანეთ ფაილები ან დააჭირეთ ატვირთვას',
      uploading: 'იტვირთება...'
    }
  },
  footer: {
    about: 'ჩვენ შესახებ',
    rights: 'ყველა უფლება დაცულია',
    poweredBy: 'შექმნილია Gstore-ს მიერ',
    delivery: 'მიწოდება',
    warranty: 'გარანტია',
    rating: 'შეფასება',
    contact: 'კონტაქტი'
  },
  results: {
    defaultTitle: 'რეზიუმე მიღებულია',
    defaultText:
      'ჩვენ მივიღეთ თქვენი რეზიუმე და ვთვლით, რომ საინტერესო კანდიდატი ხარ. ამ ეტაპზე მიმდინარეობს სხვა რეზიუმეების განხილვაც, როგორც კი შერჩევის პროცესი შემდეგ ეტაპზე გადავა, ჩვენ შეგატყობინებთ ელექტრონული ფოსტისა და მოკლე ტექსტური შეტყობინების მეშვეობით. მადლობას გიხდით დაინტერესებისთვის.',
    visitLocation: 'ვიზიტის ადგილი',
    getDirections: 'მისამართზე გადასვლა',
    slots: {
      title: 'ინტერვიუს დროის არჩევა',
      titleVisit: 'ვიზიტის დროის არჩევა'
    }
  }
};
